import React, { useState, useEffect } from "react";

const ProgressBars = () => {
  const [progress1, setProgress1] = useState(0);
  const [progress2, setProgress2] = useState(0);
  const [progress3, setProgress3] = useState(0);

  useEffect(() => {
    // Simulate progress bars
    const timer1 = setTimeout(() => setProgress1(100), 1000);
    const timer2 = setTimeout(() => setProgress2(100), 1500);
    const timer3 = setTimeout(() => setProgress3(100), 2000);

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
    };
  }, []);

  return (
    <div className="progress-container">
      <div className="progress-item">
        <div className="progress-label">Understanding your preferences</div>
        <div className="progress-bar-wrapper">
          <div className="progress-bar">
            <div
              className="progress-fill"
              style={{ width: `${progress1}%` }}
            ></div>
          </div>
          <div className="progress-percentage">{progress1}%</div>
        </div>
      </div>

      <div className="progress-item">
        <div className="progress-label">Creating personalized AI</div>
        <div className="progress-bar-wrapper">
          <div className="progress-bar">
            <div
              className="progress-fill"
              style={{ width: `${progress2}%` }}
            ></div>
          </div>
          <div className="progress-percentage">{progress2}%</div>
        </div>
      </div>

      <div className="progress-item">
        <div className="progress-label">Updating to latest AI models</div>
        <div className="progress-bar-wrapper">
          <div className="progress-bar">
            <div
              className="progress-fill"
              style={{ width: `${progress3}%` }}
            ></div>
          </div>
          <div className="progress-percentage">{progress3}%</div>
        </div>
      </div>
    </div>
  );
};

export default ProgressBars;
